import React, { useEffect, Fragment, useCallback } from 'react';
import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { getMenuItems } from '../../core/services/menu';
import { useAsync } from 'react-use';
import {} from 'react-router-dom';
import LanguageSwitcher from '../../component/LanguageSwitcher/LanguageSwitcher.jsx';

const Navbar = (props) => {
  const [toogleMenu, setToogleMenu] = useState(false);
  const [sticky, setSticky] = React.useState(false);

  const { loading: nav_links_loading, value: nav_links } = useAsync(
    getMenuItems,
    [],
  );
  const safeNavLinks = Array.isArray(nav_links) ? nav_links : [];

  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 0);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Handle menu toggle and navigation
  const handleLinkClick = useCallback(
    (path) => {
      setToogleMenu(false);
      navigate(path);
    },
    [navigate],
  );

  return (
    <Fragment>
      <div
        className={
          'wrapper__side-nav-mobile d-flex d-lg-none ' +
          (toogleMenu ? 'active' : '')
        }
      >
        <div className='d-flex flex-wrap w-100'>
          <div className='w-100'>
            <div className='d-flex align-items-center justify-content-between mb-4'>
              <NavLink
                to='/'
                exact='true'
                className='navbar-brand font__size--24 text__24-1024 semi-bold color__white'
              >
                <img
                  src='../images/main-logo.png'
                  onClick={() => setToogleMenu(!toogleMenu)}
                  className='pointer'
                  alt=''
                />
              </NavLink>

              <img
                src='./../images/Close.png'
                onClick={() => setToogleMenu(!toogleMenu)}
                className='pointer'
                alt=''
              />
            </div>

            {/* mobile nav */}
            <div className='menu'>
              {!nav_links_loading &&
                safeNavLinks.map((link, index) => (
                  <NavLink
                    key={index}
                    to={link.path}
                    className='semi-bold font__size--14 text__16-1024  color__white  text-uppercase hover'
                    onClick={() => handleLinkClick(link.path)}
                  >
                    <hr />
                    {link.title}
                  </NavLink>
                ))}
            </div>
          </div>
        </div>
      </div>
      <div
        className='bg__wrap-menu d-lg-none'
        onClick={() => setToogleMenu(!toogleMenu)}
      ></div>
      <nav
        className={`navbar navbar-expand-lg  position-relative wrapper__navbar z-2 ${
          sticky ? 'sticky' : ''
        }`}
      >
        <div className='container position-relative'>
          <NavLink to='/' exact='true'>
            <img src='../../images/main-logo.png' alt='' />
          </NavLink>
          <header className='hide-on-mobile'>
            <LanguageSwitcher />
          </header>
          <div
            className='collapse navbar-collapse ml-lg-3 page-sec'
            id='navbarSupportedContent'
          >
            <header>
              <LanguageSwitcher />
            </header>
            <ul className='navbar-nav g-15'>
              {!nav_links_loading &&
                safeNavLinks.map((link, index) => (
                  <li className='nav-item position-relative' key={link.menu_id}>
                    <div
                      className='nav-link wrapper__drodown-wrap semi-bold font__size--13 text__14-1024   text-uppercase hover pointer'
                      type='button'
                      id='dropdownMenuButton'
                      data-toggle='dropdown'
                      aria-haspopup='true'
                      aria-expanded='false'
                    >
                      <div className='d-flex align-items-center color__white '>
                        {link.title}
                        <svg
                          className='ml-2 arrow'
                          width='16'
                          height='16'
                          viewBox='0 0 16 16'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M4.70742 5.88334L4.7005 5.87711L4.69314 5.87142C4.46003 5.69119 4.12805 5.71226 3.91883 5.93027C3.69372 6.16484 3.69372 6.54105 3.91883 6.77561L7.08012 10.0697L7.08648 10.0764L7.0933 10.0825L7.13129 10.1167L7.13821 10.1229L7.14557 10.1286C7.37868 10.3088 7.71066 10.2877 7.91988 10.0697L11.0812 6.77561L11.0875 6.76903L11.0933 6.762L11.1261 6.72242L11.1319 6.71538L11.1372 6.70793C11.3037 6.47418 11.2865 6.14425 11.0812 5.93027L11.0748 5.92365L11.068 5.91751L11.03 5.88334L11.0231 5.87711L11.0157 5.87142C10.7826 5.69119 10.4506 5.71226 10.2414 5.93027C10.2414 5.93027 10.2414 5.93027 10.2414 5.93027L7.5 8.78672L4.75858 5.93027L4.75223 5.92365L4.74541 5.91751L4.70742 5.88334Z'
                            fill='white'
                            stroke='white'
                            strokeWidth='0.5'
                          />
                        </svg>
                      </div>
                    </div>

                    <div
                      className='dropdown-menu wrapper__dropdown-menu-all'
                      aria-labelledby='dropdownMenuButton'
                    >
                      {link.children &&
                        link.children.map((childLink, childIndex) => {
                          // Check for specific title to redirect
                          if (
                            childLink.title ===
                            'შეავსე იმპორტის წინასწარი შეტყობინება'
                          ) {
                            return (
                              <a
                                key={childLink.menu_id}
                                href='https://eservices.rs.ge/Login.aspx?redirect_url=https://eservices.rs.ge/Login.aspx' // External link
                                target='_blank'
                                rel='noopener noreferrer'
                                className='dropdown-item'
                              >
                                {childLink.title}
                              </a>
                            );
                          }

                          // Default rendering for other links
                          return (
                            <NavLink
                              key={childLink.menu_id}
                              to={childLink.path}
                              className='dropdown-item'
                            >
                              {childLink.title}
                            </NavLink>
                          );
                        })}
                    </div>
                  </li>
                ))}
            </ul>
          </div>

          <div
            onClick={() => setToogleMenu(!toogleMenu)}
            className='nav__button d-lg-none position-relative ml-auto flex-shrink-0'
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
          {/* <a
            href='#!'
            className='d-none d-lg-block semi-bold font__size--14 btn btn__outlined--white 
             no__opacity h__black rounded-0 shadow ml-auto text-uppercase'
          >
            button txt
          </a> */}
        </div>
      </nav>
    </Fragment>
  );
};

export default Navbar;
